import React from 'react'

import {
    COLOR,
} from '../../../business-const/Color/Color'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import {
    GridContainer,
    GridItem11,
    GridItem12,
 } from '../../../business-components/Grid/Grid'

import {
    ChartPadrao
} from '../../../business-components/Chart/Chart'

import {
    CardGridEstudoPadrao,
} from '../estudo-form/EstudoComp'

import {
    relatorioModoApresentacao,
} from '../estudo-form/EstudoService'

import {
    graficoPossuiValor,
} from '../estudo-form/EstudoServiceCalculo'

import {
    serieVazia
} from './ChartService'

import EstudoFormProjecaoSucessaoVitalicia from '../estudo-form/EstudoFormProjecaoSucessaoVitalicia'



const ProjecaoSucessaoVitaliciaChart = ( { values, estudo, report } ) => {

    const SucessaoVitalicia = ( /*props*/ ) => {

        const series = []

        const paletaCores = []



        if (graficoPossuiValor(estudo.current.graficoProjecaoSucessaoVitalicialEmergencial)) {

            series.push(
                {
                    name: LABEL.emergencial,
                    type: 'bar',
                    data: estudo.current.graficoProjecaoSucessaoVitalicialEmergencial,
                },
            )

            paletaCores.push(COLOR().corChartPadraoDespesasAcumuladasSucessaoVitaliciaEmergencial)
        }
        
        if (graficoPossuiValor(estudo.current.graficoProjecaoSucessaoVitaliciaPatrimonioImobilizado)) {

            series.push(
                {
                    name: LABEL.patrimonioImobilizado,
                    type: 'bar',
                    data: estudo.current.graficoProjecaoSucessaoVitaliciaPatrimonioImobilizado,
                },
            )

            paletaCores.push(COLOR().corChartPadraoAnalisePatrimonialAtivosPatrimonioImobilizado)
        }

        if (graficoPossuiValor(estudo.current.graficoProjecaoSucessaoVitaliciaRecursosFinanceiros)) {

            series.push(
                {
                    name: LABEL.recursosFinanceiros,
                    type: 'bar',
                    data: estudo.current.graficoProjecaoSucessaoVitaliciaRecursosFinanceiros,
                },
            )

            paletaCores.push(COLOR().corChartPadraoAnalisePatrimonialAtivosRecursosFinanceiros)
        }
            
        serieVazia(series, estudo)
    
        const categories = estudo.current.graficoProjecaoSucessaoVitaliciaIdades
    
        const GridGrafico = report ? GridItem11 : GridItem11

        return (
            //<div
            //    {...props}
            //>
                <GridContainer>
                    <GridGrafico>
                        <ChartPadrao
                            titleText={''}
                            type='area'
                            series={series}
                            stacked={true}
                            categories={categories}
                            categories2={estudo.current.graficoAnos}
                            paletaCores={paletaCores}
                            dataLabelsEnabled={values.modoApresentacao}
                            dataLabelsEnabledReport={values.formatoReport === HARDCODE.idFormatoReportImpressao}
                            dataLabelsType='Idade'
                            dataLabelsDestaque={[values.idadeVaiAposentarCliente]}
                            columnWidth='80%'
                            toolTipX={true}
                            toolTipXTotal={true}
                            report={report}
                            formatoReport={values.formatoReport}
                            modoApresentacao={values.modoApresentacao}
                            fillOpacity={0.65}//0.9
                            //fillType='gradient'
                            participacao={true}
                        />
                    </GridGrafico>
                </GridContainer>
            //</div>
        )
    }



    //const CardGridEstudoAux = values.modoApresentacao ? GridItem12 : CardGridEstudo



    return (
        <GridItem12>
            {/*report || (values.modoApresentacao && relatorioModoApresentacao(values))
                ?
                    <SucessaoVitalicia
                        //className='mt--0 ml-5' // mudança da fonte: mt-5
                    />
                :
                    <GridContainerEstudoPadraoLg
                        component={
                            <CardGridEstudoAux>
                                <CardGridDivHeaderDestaque1>
                                    <GridContainer>
                                        <GridItem12>
                                            <CardGridDivH4Destaque>
                                                {LABEL.projecaoSucessaoVitalicia}
                                            </CardGridDivH4Destaque>
                                        </GridItem12>
                                    </GridContainer>
                                </CardGridDivHeaderDestaque1>

                                <CardGridDivBody>
                                    <div
                                        className='ml-10'
                                    >
                                        <SucessaoVitalicia/>
                                    </div>
                                </CardGridDivBody>
                            </CardGridEstudoAux>
                        }
                    />
            */}

            {report// || popup
                ?
                    <SucessaoVitalicia
                        //className={(report ? "mt--5" : "mt-0") + " ml-5"} // mudança da fonte: mt-5
                    />
                :
                    <CardGridEstudoPadrao
                        label={
                            !relatorioModoApresentacao(values)
                                ?
                                    LABEL.projecaoSucessaoVitalicia
                                :
                                    HARDCODE.modoApresentacaoRelatorio
                        }
                        component={
                            <div
                                className='ml-10'
                            >
                                <SucessaoVitalicia/>
                            </div>
                        }
                        overflowX={false}
                        tabela={
                            <EstudoFormProjecaoSucessaoVitalicia
                                values={values}
                                estudo={estudo}
                                popup={true}
                            />
                        }
                        tabelaTitle={LABEL.projecaoSucessaoVitalicia}
                        modoApresentacao={values.modoApresentacao}
                        //nameListaMoreLess={moreLessList}
                        //listaMoreLess={moreLessList ? values[moreLessList] : ''}
                        //idListaMoreLess={idListaMoreLess}
                        //setFieldValue={setFieldValue}
                        //aiFTOrigem={aiFTOrigem}
                        //variaveisGlobais={variaveisGlobais}
                        //values={values}
                        //estudo={estudo}
                        //vars={vars}
                    />
            }
        </GridItem12>
    )
}

export default ProjecaoSucessaoVitaliciaChart